<template>
  <div class="p-6">
    <div class="grid grid-cols-2 gap-4">
      <div class="col-span-2 lg:col-span-1">
        <FormInput
          id="vacancyReference"
          type="text"
          :disabled="isPreview"
          :inputClass="isPreview ? 'bg-gray-100' : ''"
          :value="flowStore.activeAction.config.params.vacancyReference"
          :label="`${t('vacancy.flows.atsFields.vacancyReference')}*`"
          :onInput="updateVacancyReference"
          :rules="requiredRule"
        />
      </div>
      <div class="col-span-2 lg:col-span-1">
        <FormInput
          id="statusId"
          type="text"
          :disabled="isPreview"
          :inputClass="isPreview ? 'bg-gray-100' : ''"
          :value="flowStore.activeAction.config.params.statusId"
          :label="`${t('vacancy.flows.atsFields.statusId')}`"
          :onInput="updateStatusId"
          :rules="{}"
        />
      </div>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <div class="col-span-2 mt-8 mb-3 text-base font-medium">
        {{ t('vacancy.flows.atsFields.privateFields') }}
      </div>
      <div class="col-span-2 lg:col-span-1">
        <FormInput
          id="apiKey"
          type="password"
          :disabled="isPreview"
          :inputClass="isPreview ? 'bg-gray-100' : ''"
          :value="flowStore.activeAction.config.secretParams.apiKey"
          :label="`${t('vacancy.flows.atsFields.apiKey')}*`"
          :onInput="updateApiKey"
          :rules="requiredRule"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { required, helpers } from '@vuelidate/validators'
import { useI18n } from 'vue-i18n'
import { useFlowStore } from '../../store/flowStore'
import FormInput from '../FormInput.vue'

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
})

const requiredRule = {
  required: helpers.withMessage(t('validations.emptyField'), required),
}
const updateVacancyReference = (value) => {
  flowStore.activeAction.config.params.vacancyReference = value
}
const updateStatusId = (value) => {
  flowStore.activeAction.config.params.statusId = value
}
const updateApiKey = (value) => {
  flowStore.activeAction.config.secretParams.apiKey = value
}
const flowStore = useFlowStore()
</script>
